import { PageState } from './types'

export default {
	open: true,
	title: '',
	description: '',
	actions: [],
	breadcrumbs: [],
	sx: {},
	canGoBack: false,
	goBackParams: []
} as PageState
